import React from 'react';
import { EntityLayout } from '@backstage/plugin-catalog';
import { Grid } from '@material-ui/core';
import { RTLCatalogGraphCard } from '../../cards/CatalogGraphCard';
import { HasSystemsCard } from '../../cards/HasSystemsCard';
import { WarningCard } from '../../cards/WarningCard';
import { RTLAboutCard } from '../../cards/AboutCard';
import { SystemContextDiagramCard } from '../../cards/SystemContextDiagramCard';

export const ProviderPage = () => (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <WarningCard />
        <Grid item md={6} xs={12}>
          <RTLAboutCard />
        </Grid>
        <Grid item md={6} xs={12}>
          <RTLCatalogGraphCard height={400} />
        </Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/systems" title="Systems">
      <HasSystemsCard />
    </EntityLayout.Route>
    <EntityLayout.Route path="/context" title="System-Context">
      <SystemContextDiagramCard />
    </EntityLayout.Route>
  </EntityLayout>
);
